<template>
    
    <div class="row m-1 mt-2">
      
        <div class="col-12">
            <div class="card">
               
                <div class="card-body">
                    <div class="row">
                         
                        <div class="col-12">
                            <h1>Elenco Messaggi</h1>
                            <div class="d-none">
                                <font-awesome-icon icon="eye" ref="viewIcon"></font-awesome-icon>
                                <font-awesome-icon icon="envelope" ref="envelope"></font-awesome-icon>
                                <font-awesome-icon icon="phone" ref="phone"></font-awesome-icon>
                                <font-awesome-icon icon="circle" ref="circle"></font-awesome-icon>
                            </div>
                            <router-link class="btn btn-sm btn-primary" to="save/abc">
                                <font-awesome-icon icon="plus-circle"></font-awesome-icon> Aggiungi nuovo messaggio
                            </router-link>
                            <hr />
                            <table ref="table" id="list-msg-table" class="table table-hover table-striped w-100"></table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- /.col -->
    </div>
        
    
</template>

<script>
   
    export default {
        computed: {
           
        },
        components: {
           
        },
        data() {
            return {
            
            }
     
        },
        name: 'InheritancesList',
        beforeMount() {
            var me = this;
            window.ViewMessage = function (id) {
                me.$router.push({
                    name: "route-message",
                    params: {id:id},
                        replace: true
                    });
              
                return false;
            };
            
           
           
        },

        mounted() {
            setTimeout(
            this.loaddata,200);
        },
        methods: {
            loaddata: function () {
                   var me = this;
                if ($.fn.DataTable.isDataTable('#list-msg-table')) {
                    $('#list-msg-table').DataTable().destroy();

                }
             
            var $table = $('#list-msg-table').DataTable({
                "processing": true,
                "serverSide": true,
                "ajax": {
                    "url": window.SETTINGS.apiUrl + "/messages/list",
                    'type': 'POST',
                     "data": function (d) {
                         return JSON.stringify(d);
                    },
                    
                    'beforeSend': function (request) {
                        request.setRequestHeader("Authorization", "Bearer " + me.$store.state.user.token);
                        request.setRequestHeader("Content-Type", "application/json");
                    }
                },

                "columns": [
                    {
                        "data": "messageId", "name": "messageId", "title": "Messaggio",
                        "render": function (data, type, row, meta) {
                            var output =
                                `<div class="row">
<div class="col">
<h5><a href='#' onclick="ViewMessage('${row.messageId}')">${row.messageId}</a></h5>

</div>`
                          
                            return output;
                        }
                    }

                ]


            });

                $table.on('select', function (e, dt, type, indexes) {

                })
            }
        }
    };
</script>
